import { createRoot } from 'react-dom/client';
import App from './App';
import { FormConfigProvider } from '@leadflow/shared/src/common/contexts/FormConfigContext';
import { SUSPENSE_WRAPPER } from '@leadflow/shared/src/common/components/SuspenseWrapper/SuspenseWrapper';
import { SKELETON_LOADER_LAYOUT_PAGE } from '@leadflow/shared/src/constants/constant';
import ErrorBoundary from '@leadflow/shared/src/common/components/ErrorBoundary/ErrorBoundary';
const rootElement = document.getElementById(process.env.root || 'root');
const root = createRoot(rootElement);

// calling the config
export default root.render(
  <ErrorBoundary>
    {SUSPENSE_WRAPPER(
      <FormConfigProvider>
        <App />
      </FormConfigProvider>,
      SKELETON_LOADER_LAYOUT_PAGE,
    )}
  </ErrorBoundary>,
);
